import { TipoProduto } from "src/app/core/enums/produto.enum";
import { TipoAlerta } from "./alerta.enum";

export type SubtipoAlerta = TipoProduto;

export abstract class AlertaAbstract {

  tipoAlerta: TipoAlerta;

  subtipoAlerta: SubtipoAlerta;

  alertasConfiguracao: any[]; // TODO: AlertaConfiguracao

  abstract getAlertaDescricao(): any; // TODO: IAlertaDescricao
  
  abstract getGatilhos(): string[];

}